import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const LamnaOmdome = lazy(() => import("@/pages/LamnaOmdome"));

export const Route = createFileRoute("/lamna-omdome")({
  ssr: false,
  validateSearch: (search: Record<string, unknown>) => ({
    t: typeof search["t"] === "string" ? search["t"] : "",
    stars:
      typeof search["stars"] === "string"
        ? search["stars"]
        : typeof search["stars"] === "number"
          ? String(search["stars"])
          : "",
  }),
  head: () => ({
    meta: [
      { title: "Lämna ett omdöme | Elmarknad.se" },
      {
        name: "description",
        content: "Dela din upplevelse av Elmarknad.se på Google, Trustpilot eller Reco.",
      },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: "Lämna ett omdöme | Elmarknad.se" },
      {
        property: "og:description",
        content: "Dela din upplevelse av Elmarknad.se på Google, Trustpilot eller Reco.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => <LamnaOmdome />,
});
